import { LogOut, User } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useCurrentUser } from '@/hooks/useAuth'
import api from '@/lib/api'
import { useQueryClient } from '@tanstack/react-query'

export function Header() {
  const { data: user } = useCurrentUser()
  const queryClient = useQueryClient()

  async function handleLogout() {
    await api.delete('/sessions')
    queryClient.clear()
    window.location.href = '/users/sign_in'
  }

  return (
    <header className="flex h-16 shrink-0 items-center justify-end gap-4 border-b bg-card px-6">
      {user && (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <User className="h-4 w-4" />
          <span>{user.email}</span>
        </div>
      )}
      <Button variant="ghost" size="sm" onClick={handleLogout}>
        <LogOut className="h-4 w-4" />
        Sair
      </Button>
    </header>
  )
}
